import { ServicesViewModel } from '../../../../common/model/account/servicesViewModel';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminAccountServicesDictionarySlice = createDataFetchSlice<
  ServicesViewModel[]
>({ name: 'servicesDictionary' });
